<!-- eslint-disable sonarjs/no-vue-mixins -->
<template>
  <div v-if="canRender" class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="bazarvoicemain-container">
          <div class="row">
            <div class="col-md-3"></div>
            <div class="col-md-7">
              <h2 class="bv-title">{{ bvtitle }}</h2>
              <h3 class="bv-description">{{ bvdescription }}</h3>
            </div>
            <div class="col-md-2">
              <div class="image-container">
                <img :src="bazaarData.ReviewStatistics.BazaarVoiceLogo" alt="" />
                <div
                  class="arrow-box"
                  v-html="bazaarData.ReviewStatistics.BazaarVoiceLogoHelpText"
                ></div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <div ref="ratings" class="bazar-voice-content">
                <div class="ratings">
                  <sup> {{ bazaarData.ReviewStatistics.AverageOverallRating.toFixed(1) }}/5 </sup>
                </div>
                <div class="review">
                  {{ bazaarData.ReviewStatistics.TotalReviewCount }}
                  {{ reviews }}
                </div>
                <star-rating
                  :increment="0.01"
                  :read-only="true"
                  active-color="#fff"
                  inactive-color="#337ab7"
                  :border-width="3"
                  border-color="transparent"
                  :rounded-corners="true"
                  :rating="bazaarData.ReviewStatistics.AverageOverallRating"
                  :star-size="30"
                  :star-points="star"
                  :show-rating="false"
                ></star-rating>
              </div>
              <div class="btn-container">
                <a
                  :href="bazaarData.ReviewStatistics.WriteReviewNavigationUrl"
                  class="review-btn"
                  >{{ reviewurltext }}</a
                >
              </div>
            </div>
            <div class="col-md-6">
              <div class="rating-snapshot-container">
                <h3 class>{{ averageratingtitle }}</h3>
                <div class="inner-container">
                  <div class="col-md-3 left-content">
                    <star-rating
                      v-for="slider in datas"
                      :key="slider"
                      :increment="0.01"
                      :read-only="true"
                      active-color="#337ab7"
                      :border-width="3"
                      border-color="transparent"
                      :rounded-corners="true"
                      :rating="slider.rating"
                      :star-size="30"
                      :star-points="star"
                      :show-rating="false"
                    ></star-rating>
                  </div>
                  <div class="col-md-7 middle-content" style="padding: 0">
                    <div class="col-md-10 progress-content">
                      <div v-for="count in high" :key="count" class="progress-content">
                        <div
                          class="prgress-bg progress-bar"
                          role="progressbar"
                          :aria-label="`${ariaLabel.progress}${count}`"
                          :style="{ width: (count / total) * 100 + '%' }"
                        ></div>
                      </div>
                    </div>
                    <div class="col-md-2 right-content">
                      <p v-for="count in datas" :key="count">
                        {{ count.cout }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="review-right">
                <div v-for="slider in labelArr" :key="slider" class="right-content">
                  <div class="ratingss">
                    <p>{{ slider.Label }}</p>
                    <star-rating
                      :increment="0.01"
                      :read-only="true"
                      active-color="#337ab7"
                      :border-width="3"
                      border-color="transparent"
                      :rounded-corners="true"
                      :rating="slider.AverageRating"
                      :star-size="30"
                      :star-points="star"
                      :show-rating="false"
                    ></star-rating>
                  </div>
                  <div class="points">
                    {{ slider.AverageRating.toFixed(1) }}
                  </div>
                  <div style="clear: both"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- BV Rating list start -->
        <div class="search-sort-container">
          <div class="row">
            <div class="col-sm-6 col-md-5 col-lg-4">
              <div class="search-container">
                <div class="search-input">
                  <input
                    v-model="reviewSearch"
                    type="text"
                    :placeholder="posts.SearchPlaceholder"
                    @keyup.enter="searchdatanew()"
                  />
                  <button
                    class="search-btn"
                    :aria-label="ariaLabel.search"
                    data-toggle="modal"
                    @click="searchdatanew()"
                  ></button>
                </div>
              </div>
            </div>
            <div class="col-md-2 col-lg-4"></div>
            <div class="col-sm-6 col-md-5 col-lg-4">
              <div class="sort-container">
                <div class="question">
                  <div
                    class="arrow-box"
                    v-html="bazaarData.ReviewStatistics.RelevancyLinkDescription"
                  ></div>
                </div>
                <div class="sort">
                  <span>{{ posts.SortBy }} : </span>
                  <div class="sort-custom-select">
                    <select
                      v-model="sortdatass"
                      :aria-label="ariaLabel.sort"
                      @change="sortDatas($event)"
                    >
                      <option
                        v-for="x in bazaarData.ReviewStatistics.SortOptions"
                        :key="x.key"
                        :value="x.key"
                      >
                        {{ x.value }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="list-container" @click="isHidden = !isHidden">
                  <span></span><span></span><span></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="filter-container">
          <div class="row">
            <div class="col-md-12">
              <div v-show="!isHidden" class="dropdown-container">
                <div class="dropdown">
                  <button
                    class="btn dropdown-toggle"
                    type="button"
                    data-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {{ bazaarData.ReviewStatistics.FilterCategory[0].Value }}
                    <span class="caret"></span>
                  </button>
                  <ul class="dropdown-menu">
                    <li
                      v-for="(x, index) in bazaarData.ReviewStatistics.FilterCategory[0]
                        .FilterValues"
                      :key="index"
                      @click="FilterCategory0(x)"
                    >
                      <a>{{ x.value }}</a>
                    </li>
                  </ul>
                </div>
                <span
                  v-if="bazaarData.ReviewStatistics.ContextDataDistributionOrder.includes('Age')"
                >
                  <div class="dropdown">
                    <button
                      class="btn dropdown-toggle"
                      type="button"
                      data-toggle="dropdown"
                      aria-expanded="false"
                    >
                      {{ bazaarData.ReviewStatistics.FilterCategory[1].Value }}
                      <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu">
                      <li
                        v-for="(x, index) in bazaarData.ReviewStatistics.FilterCategory[1]
                          .FilterValues"
                        :key="index"
                        @click="FilterCategory1(x)"
                      >
                        <a>{{ x.value }}</a>
                      </li>
                    </ul>
                  </div>
                </span>
                <span
                  v-if="bazaarData.ReviewStatistics.ContextDataDistributionOrder.includes('Gender')"
                >
                  <div class="dropdown">
                    <button
                      class="btn dropdown-toggle"
                      type="button"
                      data-toggle="dropdown"
                      aria-expanded="false"
                    >
                      {{ bazaarData.ReviewStatistics.FilterCategory[2].Value }}
                      <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu">
                      <li
                        v-for="(x, index) in bazaarData.ReviewStatistics.FilterCategory[2]
                          .FilterValues"
                        :key="index"
                        @click="FilterCategory2(x)"
                      >
                        <a>{{ x.value }}</a>
                      </li>
                    </ul>
                  </div>
                </span>
                <span
                  v-if="
                    bazaarData.ReviewStatistics.ContextDataDistributionOrder.includes('Produkttest')
                  "
                >
                  <div class="dropdown">
                    <button
                      class="btn dropdown-toggle"
                      type="button"
                      data-toggle="dropdown"
                      aria-expanded="false"
                    >
                      {{ bazaarData.ReviewStatistics.FilterCategory[3].Value }}
                      <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu">
                      <li
                        v-for="(x, index) in bazaarData.ReviewStatistics.FilterCategory[3]
                          .FilterValues"
                        :key="index"
                        @click="FilterCategory3(x)"
                      >
                        <a>{{ x.value }}</a>
                      </li>
                    </ul>
                  </div>
                </span>
                <span
                  v-if="
                    bazaarData.ReviewStatistics.ContextDataDistributionOrder.includes('Gewinnspiel')
                  "
                >
                  <div class="dropdown">
                    <button
                      class="btn dropdown-toggle"
                      type="button"
                      data-toggle="dropdown"
                      aria-expanded="false"
                    >
                      {{ bazaarData.ReviewStatistics.FilterCategory[4].Value }}
                      <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu">
                      <li
                        v-for="(x, index) in bazaarData.ReviewStatistics.FilterCategory[4]
                          .FilterValues"
                        :key="index"
                        @click="FilterCategory4(x)"
                      >
                        <a>{{ x.value }}</a>
                      </li>
                    </ul>
                  </div>
                </span>
                <div class="dropdown">
                  <button
                    class="btn dropdown-toggle"
                    type="button"
                    data-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {{ bazaarData.ReviewStatistics.FilterCategory[5].Value }}
                    <span class="caret"></span>
                  </button>
                  <ul class="dropdown-menu">
                    <li
                      v-for="(x, index) in bazaarData.ReviewStatistics.FilterCategory[5]
                        .FilterValues"
                      :key="index"
                      @click="FilterCategory5(x)"
                    >
                      <a>{{ x.value }}</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="
            (filterKey0a.length != 0) |
              (filterKey1a.length != 0) |
              (filterKey2a.length != 0) |
              (filterKey3a.length != 0) |
              (filterKey4a.length != 0) |
              (filterKey5a.length != 0)
          "
          class="filter-container-tags"
        >
          <div class="row">
            <div class="col-md-12">
              <p>{{ posts.ActiveFilter }}</p>
              <div v-for="(x, index) in filterKey0a" :key="index">
                <div class="filtertag" @click="FilterCategory0(x)">
                  {{ x.value }}
                  <span>×</span>
                </div>
              </div>
              <div v-for="(x, index) in filterKey1a" :key="index">
                <div class="filtertag" @click="FilterCategory1(x)">
                  {{ x.value }}
                  <span>×</span>
                </div>
              </div>
              <div v-for="(x, index) in filterKey2a" :key="index">
                <div class="filtertag" @click="FilterCategory2(x)">
                  {{ x.value }}
                  <span>×</span>
                </div>
              </div>
              <div v-for="(x, index) in filterKey3a" :key="index">
                <div class="filtertag" @click="FilterCategory3(x)">
                  {{ x.value }}
                  <span>×</span>
                </div>
              </div>
              <div v-for="(x, index) in filterKey4a" :key="index">
                <div class="filtertag" @click="FilterCategory4(x)">
                  {{ x.value }}
                  <span>×</span>
                </div>
              </div>
              <div v-for="(x, index) in filterKey5a" :key="index">
                <div class="filtertag" @click="FilterCategory5(x)">
                  {{ x.value }}
                  <span>×</span>
                </div>
              </div>

              <div class="filtertag removebtn" @click="RemoveAll()">
                {{ posts.ClearAllText }}
                <span>×</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--  search popup  -->
    <div v-if="popupstatus" class="modal right fade in" :class="{ 'popupstatus in': popupstatus }">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" @click="closeSearchPopup">&times;</button>
            <div class="search-sort-container">
              <div class="search-container">
                <div class="search-input">
                  <input
                    v-model="reviewSearch"
                    type="text"
                    :placeholder="posts.SearchPlaceholder"
                    @keyup.enter="searchdatanew()"
                  />
                  <button
                    type="submit"
                    class="search-btn"
                    data-toggle="modal"
                    data-target="#searchmodelfirst"
                    @click="searchdatanew()"
                  ></button>
                </div>
              </div>
            </div>
            <h2 class="modal-title">{{ searchingresults.SearchResults }}</h2>
          </div>
          <div class="modal-body">
            <div v-if="searchingresults.Results">
              <div
                v-for="slider in searchingresults.Results"
                :key="slider.Id"
                class="search-result-container"
              >
                <div class="rating-container">
                  <div class="ratingss">
                    <star-rating
                      :increment="0.01"
                      :read-only="true"
                      active-color="#337ab7"
                      :border-width="3"
                      border-color="transparent"
                      :rounded-corners="true"
                      :rating="slider.Rating"
                      :star-size="30"
                      :star-points="star"
                      :show-rating="false"
                    ></star-rating>
                  </div>
                  <span :key="slider.UserNickname" class="searchname">{{
                    slider.UserNickname
                  }}</span>
                  <span :key="slider.SubmissionTime" class="searchtime">{{
                    slider.SubmissionTime
                  }}</span>
                </div>
                <h4
                  :key="slider.Title"
                  v-highlight="{ keyword: reviewSearch, separator: ' ', style: 'color: #0075ba' }"
                >
                  {{ slider.Title }}
                </h4>
                <p
                  :key="slider.ReviewText"
                  v-highlight="{ keyword: reviewSearch, separator: ' ', style: 'color: #00000' }"
                >
                  {{ slider.ReviewText }}
                </p>
              </div>
            </div>
            <div v-if="searchingresults.Results == 0">
              <p>{{ searchingresults.NoResults }}</p>
            </div>
          </div>
          <div class="modal-footer">
            <div class="bazaarvoiceReview-container">
              <div
                v-if="!searchingresults.Results.length == 0 || TotalResults >= 2"
                class="pagination-container"
              >
                <div class="col-md-12">
                  <div class="inner-container">
                    <div class="left-triangle" @click="getsearchdatasBack()"></div>
                    <p class="text-content">
                      <span :key="searchcurrentPaginationPage">{{
                        searchcurrentPaginationPage
                      }}</span>
                      <span :key="posts.PaginationText">{{ posts.PaginationText }}</span>
                      <span :key="searchshowPagination">{{ searchshowPagination }}</span>
                    </p>
                    <div class="right-triangle" @click="getsearchdatasNext()"></div>
                    <div style="clear: both"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="searchmodelsecond" class="modal right fade" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title">Modal Header</h4>
          </div>
          <div class="modal-body">
            <p>model2</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
    <!-- search popup -->
    <div
      v-for="(slider, index) in posts.Results"
      :key="slider.Id"
      class="bazaarvoiceReview-container"
    >
      <div class="row">
        <div class="col-md-4">
          <div class="profile-container">
            <div class="image-container">
              <img
                v-if="
                  slider.ContextDataValues.Gender != undefined &&
                  slider.ContextDataValues.Gender.Value == 'Female'
                "
                src="/images/assets/avatar/FEMALE.png"
                :style="{ width: 90 + 'px', height: 90 + 'px' }"
                alt=""
              />
              <img
                v-else
                src="/images/assets/avatar/MALE.png"
                :style="{ width: 90 + 'px', height: 90 + 'px' }"
                alt=""
              />
            </div>
            <div class="description-container">
              <p :key="slider.UserNickname" class="title">{{ slider.UserNickname }}</p>
              <p v-if="slider.UserLocation != undefined && slider.UserLocation != ''">
                <span :key="datass.UserLocationText">{{ datass.UserLocationText }} </span>
                <span :key="slider.UserLocation">{{ slider.UserLocation }}</span>
              </p>
              <p v-if="datass.AuthorsReviewCount[index] != ''">
                <span :key="datass.UserRatingText">{{ datass.UserRatingText }} </span>
                <span :key="datass.AuthorsReviewCount[index]"
                  >{{ datass.AuthorsReviewCount[index] }}
                </span>
              </p>
              <p v-if="slider.TotalPositiveFeedbackCount != ''">
                <span :key="datass.UserVotesText">{{ datass.UserVotesText }} </span>
                <span :key="slider.TotalPositiveFeedbackCount"
                  >{{ slider.TotalPositiveFeedbackCount }}
                </span>
              </p>
              <span v-if="slider.ContextDataValues.Age != undefined">
                <p>
                  <span :key="slider.ContextDataValues.Age.DimensionLabel"
                    >{{ slider.ContextDataValues.Age.DimensionLabel }}
                  </span>
                  <span :key="slider.ContextDataValues.Age.ValueLabel">{{
                    slider.ContextDataValues.Age.ValueLabel
                  }}</span>
                </p>
              </span>
              <span v-if="slider.ContextDataValues.Gender != undefined">
                <p>
                  {{ slider.ContextDataValues.Gender.DimensionLabel }}
                  <span :key="slider.ContextDataValues.Gender.ValueLabel">{{
                    slider.ContextDataValues.Gender.ValueLabel
                  }}</span>
                </p>
              </span>
              <div
                v-if="incentivizedreview != ''"
                ref="incentivizedReviews"
                class="incentivized-review"
              >
                <button
                  type="button"
                  class="review-button"
                  :aria-expanded="openIncentivizedReviewId === slider.Id"
                  :aria-controls="`incentivized-review-tooltip-${slider.Id}`"
                  @click="toggleIncentivizedReview(slider.Id)"
                >
                  {{ incentivizedreviewtitle }}
                </button>
                <div
                  v-if="openIncentivizedReviewId === slider.Id"
                  :id="`incentivized-review-tooltip-${slider.Id}`"
                  class="review-tooltip"
                  role="tooltip"
                >
                  <button
                    type="button"
                    class="review-tooltip-close"
                    aria-label="Close"
                    @click="closeIncentivizedReview"
                  >
                    &times;
                  </button>
                  {{ incentivizedreview }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-8">
          <div class="product-container">
            <div class="image-container">
              <img :src="bazaarData.ImageUrl" alt="" />
            </div>
            <div class="prodcut-description-container">
              <p
                v-if="
                  slider.ContextDataValues.Gender != undefined &&
                  slider.ContextDataValues.Gender.Value == 'Female'
                "
              >
                {{ datass.HerFavouriteProduct }}
              </p>
              <p v-else>{{ datass.HisFavouriteProduct }}</p>
              <h3>{{ bazaarData.Name }}</h3>
              <div class="star-rating-container">
                <star-rating
                  :increment="0.01"
                  :read-only="true"
                  active-color="#337ab7"
                  :border-width="3"
                  border-color="transparent"
                  :rounded-corners="true"
                  :rating="slider.Rating"
                  :star-size="30"
                  :star-points="star"
                  :show-rating="false"
                ></star-rating>
              </div>
              <h5 :key="slider.SubmissionTime">{{ slider.SubmissionTime }}</h5>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="reivew-container">
          <div class="col-md-9">
            <div class="inner-container">
              <h4 :key="slider.Title">{{ slider.Title }}</h4>
              <p :key="slider.ReviewText">{{ slider.ReviewText }}</p>
            </div>
          </div>
          <div class="col-md-3">
            <div class="ratingss">
              <div v-if="slider.SecondaryRatings.VertraglichkeitBew">
                <p :key="slider.SecondaryRatings.VertraglichkeitBew.Label">
                  {{ slider.SecondaryRatings.VertraglichkeitBew.Label }}
                </p>
                <star-rating
                  :increment="0.01"
                  :read-only="true"
                  active-color="#337ab7"
                  :border-width="3"
                  border-color="transparent"
                  :rounded-corners="true"
                  :rating="slider.SecondaryRatings.VertraglichkeitBew.Value"
                  :star-size="30"
                  :star-points="star"
                  :show-rating="false"
                ></star-rating>
              </div>
              <div v-if="slider.SecondaryRatings.WieBewertestDuDenDuft_1">
                <p>
                  {{ slider.SecondaryRatings.WieBewertestDuDenDuft_1.Label }}
                </p>
                <star-rating
                  :increment="0.01"
                  :read-only="true"
                  active-color="#337ab7"
                  :border-width="3"
                  border-color="transparent"
                  :rounded-corners="true"
                  :rating="slider.SecondaryRatings.WieBewertestDuDenDuft_1.Value"
                  :star-size="30"
                  :star-points="star"
                  :show-rating="false"
                ></star-rating>
              </div>
              <div v-if="slider.SecondaryRatings.Effizienz">
                <p>{{ slider.SecondaryRatings.Effizienz.Label }}</p>
                <star-rating
                  :increment="0.01"
                  :read-only="true"
                  active-color="#337ab7"
                  :border-width="3"
                  border-color="transparent"
                  :rounded-corners="true"
                  :rating="slider.SecondaryRatings.Effizienz.Value"
                  :star-size="30"
                  :star-points="star"
                  :show-rating="false"
                ></star-rating>
              </div>
              <div v-if="slider.SecondaryRatings.Feuchtigkeitswirkung_1">
                <p>
                  {{ slider.SecondaryRatings.Feuchtigkeitswirkung_1.Label }}
                </p>
                <star-rating
                  :increment="0.01"
                  :read-only="true"
                  active-color="#337ab7"
                  :border-width="3"
                  border-color="transparent"
                  :rounded-corners="true"
                  :rating="slider.SecondaryRatings.Feuchtigkeitswirkung_1.Value"
                  :star-size="30"
                  :star-points="star"
                  :show-rating="false"
                ></star-rating>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="comment-container">
          <div v-if="slider.IsRecommended == null" class="col-md-4"></div>
          <div v-if="slider.IsRecommended == true" class="col-md-4">
            <div class="left-comment">
              <h4 :key="datass.RecommendedText">{{ datass.RecommendedText }}</h4>
            </div>
          </div>
          <div v-if="slider.IsRecommended == false" class="col-md-4">
            <div :key="datass.NotRecommendedText" class="left-comment">
              <h4 class="txtcolor">{{ datass.NotRecommendedText }}</h4>
            </div>
          </div>
          <div v-if="!slider.IsSyndicated" class="col-md-8">
            <div class="right-comment">
              <h4>
                <span :key="datass.Helpfullness" class="helptext">{{ datass.Helpfullness }}</span>
                <span
                  v-if="!slider.cookieStatus"
                  :key="datass.PositiveCountText"
                  class="mixa-mouse-pointer"
                  @click="helpfullyes(slider.Id, 'yes', slider.TotalPositiveFeedbackCount)"
                >
                  {{ datass.PositiveCountText }}</span
                >
                <span
                  v-if="slider.cookieStatus"
                  :key="datass.PositiveCountText"
                  class="mixa-mouse-pointer-disable"
                >
                  {{ datass.PositiveCountText }}</span
                >
                |
                <span :key="slider.TotalPositiveFeedbackCount" class="number">
                  {{ slider.TotalPositiveFeedbackCount }}
                </span>
                <span
                  v-if="!slider.cookieStatus"
                  :key="datass.NegativeCountText"
                  class="mixa-mouse-pointer"
                  @click="helpfullno(slider.Id, 'no', slider.TotalNegativeFeedbackCount)"
                  >{{ datass.NegativeCountText }}</span
                >
                <span
                  v-if="slider.cookieStatus"
                  :key="datass.NegativeCountText"
                  class="mixa-mouse-pointer-disable"
                  >{{ datass.NegativeCountText }}</span
                >
                |
                <span :key="slider.TotalNegativeFeedbackCount" class="number">
                  {{ slider.TotalNegativeFeedbackCount }}
                </span>
                <span
                  v-if="!slider.reportStatus"
                  :key="datass.ReportText"
                  class="mixa-mouse-pointer"
                  @click="helpfullreport(slider.Id, 'appropriate')"
                >
                  {{ datass.ReportText }}
                </span>
                <span
                  v-if="slider.reportStatus"
                  :key="datass.ReportedText"
                  class="mixa-mouse-pointer-disable"
                  >{{ datass.ReportedText }}
                </span>
              </h4>
            </div>
          </div>
        </div>
      </div>
      <div v-if="slider.IsSyndicated" class="row">
        <div class="SyndicationSource-container">
          <div class="col-md-2">
            <div class="image-container">
              <a :aria-label="ariaLabel.readmore" :href="slider.SyndicationSource.ContentLink">
                <img :src="slider.SyndicationSource.LogoImageUrl" alt="" />
              </a>
            </div>
          </div>
          <div class="col-md-10">
            <p>{{ datass.SyndicationText }} {{ slider.SyndicationSource.Name }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- BV Rating list end -->
    <div class="bazaarvoiceReview-container">
      <div class="row">
        <div v-if="!posts.TotalResults == 0" class="pagination-container">
          <div class="col-md-12">
            <div class="inner-container">
              <div class="left-triangle" @click="getdatasBack()"></div>
              <p class="text-content">
                <span :key="currentPaginationPage">{{ currentPaginationPage }}</span>
                <span :key="posts.PaginationText">{{ posts.PaginationText }}</span>
                <span :key="showPagination">{{ showPagination }}</span>
              </p>
              <div class="right-triangle" @click="getdatasNext()"></div>
              <div style="clear: both"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import StarRating from 'vue-star-rating';
import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en';
import de from 'javascript-time-ago/locale/de';

import throttle from 'lodash/throttle';
export function isVisible(element) {
  if (!element) return;
  const elementCenter = {
    x: element.getBoundingClientRect().left + element.offsetWidth / 2,
    y: element.getBoundingClientRect().top + element.offsetHeight / 2,
  };
  let pointContainer = document.elementFromPoint(elementCenter.x, elementCenter.y);

  if (
    elementCenter.x < 0 ||
    elementCenter.y < 0 ||
    elementCenter.x > (document.documentElement.clientWidth || window.innerWidth) ||
    elementCenter.y > (document.documentElement.clientHeight || window.innerHeight)
  ) {
    return false;
  }

  do {
    if (pointContainer === element) {
      return true;
    }
  } while ((pointContainer = pointContainer.parentNode));

  return false;
}
export function isElementInViewportTag(element) {
  const rect = element.getBoundingClientRect();

  const isInViewPort =
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth);

  return isInViewPort;
}
// Add locale-specific relative date/time formatting rules.
TimeAgo.addLocale(en);
TimeAgo.addLocale(de);

// Create relative date/time formatter.
const timeAgo = new TimeAgo('de');
import otMixins from '../../mixins/ot-mixins';
import { EventBus } from '../../mixins/event';
import { OTConsentEmitters } from '../../mixins/constants';

/* eslint-disable */
export default {
  name: 'bazaarvoice-main',
  components: {
    StarRating,
  },

  mixins: [otMixins],
  props: {
    bazaarData: {
      type: Object,
      required: true,
    },
    productId: {
      type: String,
      required: true,
    },
    bvdescription: {
      type: String,
      required: true,
    },
    averageratingtitle: {
      type: String,
      required: true,
    },
    bvtitle: {
      type: String,
      required: true,
    },
    reviews: {
      type: String,
      required: true,
    },
    currentlocale: {
      type: String,
      required: true,
    },
    reviewurltext: {
      type: String,
      required: true,
    },
    isConsentEnabled: {
      type: Boolean,
      default: false,
    },
    ariaLabel: {
      type: Object,
      required: true,
    },
    incentivizedreview: {
        type: String,
        default: ''
    },
    incentivizedreviewtitle: {
        type: String,
        default: ''
    }
  },
  data() {
    return {
      datas: [],
      labelArr: [],
      high: [],
      total: 0,
      getlen: null,
      datass: {},
      star: [23, 2, 14, 17, 0, 19, 10, 34, 7, 50, 23, 43, 38, 50, 36, 34, 46, 19, 31, 17],
      offset: 0,
      pagination: 1,
      posts: [],
      searchresults: {},
      searchingresults: [],
      paginationValidation: 0,
      searchpaginationValidation: 0,
      TotalResultsValidation: 0,
      showPagination: 0,
      searchshowPagination: 0,
      currentPaginationPage: 1,
      searchcurrentPaginationPage: 1,
      localstorageDatas: [],
      localstorageDatasReport: [],
      sortdatass: this.bazaarData.ReviewStatistics.SortOptions[0].key,
      isHidden: true,
      reviewSearch: '',
      text: '',
      words: '',
      popupstatus: false,
      overWriteStyle: {
        color: 'black',
        weight: 'bold',
      },
      filterOld: '',
      filterGender: '',
      filterProducttest: '',
      filterCompetition: '',
      filterRegion: '',
      filterKey0: '',
      filterKey0a: [],
      filterKey1: '',
      filterKey1a: [],
      filterKey2: '',
      filterKey2a: [],
      filterKey3: '',
      filterKey3a: [],
      filterKey4: '',
      filterKey4a: [],
      filterKey5: '',
      filterKey5a: [],
      filterRating0: '',
      filterRating1: '',
      filterRating2: '',
      filterRating3: '',
      filterRating4: '',
      filterRating5: '',
      canRender: false,
      reviewsLoaded: false,
      otReviewEmitter: OTConsentEmitters.OTBazaarVoiceEmitter,
       openIncentivizedReviewId: null,
    };
  },
  created() {
    EventBus.$on(this.otReviewEmitter, this.onConsentStatus);
  },
  beforeDestroy() {
    EventBus.$off(this.otReviewEmitter, this.onConsentStatus);
  },
  beforeMount() {
    this.ratingCount = this.bazaarData.ReviewStatistics.RatingDistribution.length;
  },
  mounted() {
    let polyfillScript = document.createElement('script');
    polyfillScript.setAttribute(
      'src',
      'https://cdnjs.cloudflare.com/polyfill/v3/polyfill.min.js?features=es6%2CIntl%2CArray.prototype.includes%2CArray.prototype.find%2CArray.prototype.findIndex&flags=gated',
    );
    document.head.appendChild(polyfillScript);
    this.startData();
    this.productLabel();
    this.highest();
    this.fireImpression();
    document.addEventListener('click', this.handleIncentivizedReviewOutsideClick);

  },
  methods: {
    onConsentStatus(status) {
      this.canRender = status;
      this.maybeLoadReviews();
    },
    maybeLoadReviews() {
      if (!this.canRender || !this.productId || this.reviewsLoaded) {
        return;
      }
      this.reviewsLoaded = true;
      this.getdatas(0);
    },
    toggleIncentivizedReview(reviewId) {
        this.openIncentivizedReviewId = this.openIncentivizedReviewId === reviewId
          ? null
          : reviewId;
    },
    closeIncentivizedReview() {
        this.openIncentivizedReviewId = null;
    },
    handleIncentivizedReviewOutsideClick(event) {
        if (this.openIncentivizedReviewId === null) {
          return;
        }
        const reviewElements = this.$refs.incentivizedReviews || [];
        const elements = Array.isArray(reviewElements) ? reviewElements : [reviewElements];
        if (!elements.some(element => element.contains(event.target))) {
          this.closeIncentivizedReview();
        }
    },
    fireImpression() {
      const scrollCallback = () => {
        if (isVisible(this.$refs.ratings)) {
          try {
            dataLayer.push({
              event: 'uaevent',
              eventCategory: 'product detail page',
              eventAction: 'consult a review',
            });
          } catch (e) {
            console.warn('datalayer is not defined', e);
          }
          window.removeEventListener('scroll', throttledScrollCallback);
        }
      };
      const throttledScrollCallback = throttle(scrollCallback, 500);
      window.addEventListener('scroll', throttledScrollCallback, false);
    },
    FilterCategory0(val) {
      if (this.filterKey0 === '') {
        this.filterKey0 = val.key;
      } else {
        this.filterKey0 = `${this.filterKey0}%2c${val.key}`;
      }
      this.filterKey0a.push(val);
      let duplicates = this.filterKey0.split('%2c').reduce(function (acc, el, i, arr) {
        if (arr.indexOf(el) !== i && acc.indexOf(el) < 0) acc.push(el);
        return acc;
      }, []);
      this.filterKey0 = this.filterKey0.split('%2c');
      this.filterKey0 = [...new Set(this.filterKey0)];
      // dropdown duplication............ start
      let arr = '';
      for (let i = 0; i < this.filterKey0.length; i++) {
        if (this.filterKey0[i] != duplicates[0]) {
          if (arr === '') {
            arr = this.filterKey0[i];
          } else {
            arr = `${arr}%2c${this.filterKey0[i]}`;
          }
        }
      }
      // dropdown duplication............ end
      // label duplication ................. start
      this.filterKey0a = Object.values(
        this.filterKey0a.reduce((a, c) => {
          a[c.key] = c;
          return a;
        }, {}),
      );
      let arr2 = [];
      for (let i = 0; i < this.filterKey0a.length; i++) {
        if (this.filterKey0a[i].key != duplicates[0]) {
          arr2.push(this.filterKey0a[i]);
        }
      }
      this.filterKey0a = arr2;
      // label duplication ......................... end
      this.filterKey0 = arr;
      this.filterRating0 = `filters=${this.bazaarData.ReviewStatistics.FilterCategory[0].Key}:${this.filterKey0}`;
      this.getdatas(0);
      this.paginationValidation = 0;
      this.currentPaginationPage = 1;
    },
    FilterCategory1(val) {
      if (this.filterKey1 === '') {
        this.filterKey1 = val.key;
      } else {
        this.filterKey1 = `${this.filterKey1}%2c${val.key}`;
      }
      this.filterKey1a.push(val);
      let duplicates = this.filterKey1.split('%2c').reduce(function (acc, el, i, arr) {
        if (arr.indexOf(el) !== i && acc.indexOf(el) < 0) acc.push(el);
        return acc;
      }, []);
      this.filterKey1 = this.filterKey1.split('%2c');
      this.filterKey1 = [...new Set(this.filterKey1)];
      // dropdown duplication............ start
      let arr = '';
      for (let i = 0; i < this.filterKey1.length; i++) {
        if (this.filterKey1[i] != duplicates[0]) {
          if (arr === '') {
            arr = this.filterKey1[i];
          } else {
            arr = `${arr}%2c${this.filterKey1[i]}`;
          }
        }
      }
      // dropdown duplication............ end
      // label duplication ................. start
      this.filterKey1a = Object.values(
        this.filterKey1a.reduce((a, c) => {
          a[c.key] = c;
          return a;
        }, {}),
      );
      let arr2 = [];
      for (let i = 0; i < this.filterKey1a.length; i++) {
        if (this.filterKey1a[i].key != duplicates[0]) {
          arr2.push(this.filterKey1a[i]);
        }
      }
      this.filterKey1a = arr2;
      // label duplication ......................... end
      this.filterKey1 = arr;
      this.filterRating1 = `filters=${this.bazaarData.ReviewStatistics.FilterCategory[1].Key}:${this.filterKey1}`;
      this.getdatas(0);
      this.paginationValidation = 0;
      this.currentPaginationPage = 1;
    },
    FilterCategory2(val) {
      if (this.filterKey2 === '') {
        this.filterKey2 = val.key;
      } else {
        this.filterKey2 = `${this.filterKey2}%2c${val.key}`;
      }
      this.filterKey2a.push(val);
      let duplicates = this.filterKey2.split('%2c').reduce(function (acc, el, i, arr) {
        if (arr.indexOf(el) !== i && acc.indexOf(el) < 0) acc.push(el);
        return acc;
      }, []);
      this.filterKey2 = this.filterKey2.split('%2c');
      this.filterKey2 = [...new Set(this.filterKey2)];
      // dropdown duplication............ start
      let arr = '';
      for (let i = 0; i < this.filterKey2.length; i++) {
        if (this.filterKey2[i] != duplicates[0]) {
          if (arr === '') {
            arr = this.filterKey2[i];
          } else {
            arr = `${arr}%2c${this.filterKey2[i]}`;
          }
        }
      }
      // dropdown duplication............ end
      // label duplication ................. start
      this.filterKey2a = Object.values(
        this.filterKey2a.reduce((a, c) => {
          a[c.key] = c;
          return a;
        }, {}),
      );
      let arr2 = [];
      for (let i = 0; i < this.filterKey2a.length; i++) {
        if (this.filterKey2a[i].key != duplicates[0]) {
          arr2.push(this.filterKey2a[i]);
        }
      }
      this.filterKey2a = arr2;
      // label duplication ......................... end
      this.filterKey2 = arr;
      this.filterRating2 = `filters=${this.bazaarData.ReviewStatistics.FilterCategory[2].Key}:${this.filterKey2}`;
      this.getdatas(0);
      this.paginationValidation = 0;
      this.currentPaginationPage = 1;
    },
    FilterCategory3(val) {
      if (this.filterKey3 === '') {
        this.filterKey3 = val.key;
      } else {
        this.filterKey3 = `${this.filterKey3}%2c${val.key}`;
      }
      this.filterKey3a.push(val);
      let duplicates = this.filterKey3.split('%2c').reduce(function (acc, el, i, arr) {
        if (arr.indexOf(el) !== i && acc.indexOf(el) < 0) acc.push(el);
        return acc;
      }, []);
      this.filterKey3 = this.filterKey3.split('%2c');
      this.filterKey3 = [...new Set(this.filterKey3)];
      // dropdown duplication............ start
      let arr = '';
      for (let i = 0; i < this.filterKey3.length; i++) {
        if (this.filterKey3[i] != duplicates[0]) {
          if (arr === '') {
            arr = this.filterKey3[i];
          } else {
            arr = `${arr}%2c${this.filterKey3[i]}`;
          }
        }
      }
      // dropdown duplication............ end
      // label duplication ................. start
      this.filterKey3a = Object.values(
        this.filterKey3a.reduce((a, c) => {
          a[c.key] = c;
          return a;
        }, {}),
      );
      let arr2 = [];
      for (let i = 0; i < this.filterKey3a.length; i++) {
        if (this.filterKey3a[i].key != duplicates[0]) {
          arr2.push(this.filterKey3a[i]);
        }
      }
      this.filterKey3a = arr2;
      // label duplication ......................... end
      this.filterKey3 = arr;
      this.filterRating3 = `filters=${this.bazaarData.ReviewStatistics.FilterCategory[3].Key}:${this.filterKey3}`;
      this.getdatas(0);
      this.paginationValidation = 0;
      this.currentPaginationPage = 1;
    },
    FilterCategory4(val) {
      if (this.filterKey4 === '') {
        this.filterKey4 = val.key;
      } else {
        this.filterKey4 = `${this.filterKey4}%2c${val.key}`;
      }
      this.filterKey4a.push(val);
      let duplicates = this.filterKey4.split('%2c').reduce(function (acc, el, i, arr) {
        if (arr.indexOf(el) !== i && acc.indexOf(el) < 0) acc.push(el);
        return acc;
      }, []);
      this.filterKey4 = this.filterKey4.split('%2c');
      this.filterKey4 = [...new Set(this.filterKey4)];
      // dropdown duplication............ start
      let arr = '';
      for (let i = 0; i < this.filterKey4.length; i++) {
        if (this.filterKey4[i] != duplicates[0]) {
          if (arr === '') {
            arr = this.filterKey4[i];
          } else {
            arr = `${arr}%2c${this.filterKey4[i]}`;
          }
        }
      }
      // dropdown duplication............ end
      // label duplication ................. start
      this.filterKey4a = Object.values(
        this.filterKey4a.reduce((a, c) => {
          a[c.key] = c;
          return a;
        }, {}),
      );
      let arr2 = [];
      for (let i = 0; i < this.filterKey4a.length; i++) {
        if (this.filterKey4a[i].key != duplicates[0]) {
          arr2.push(this.filterKey4a[i]);
        }
      }
      this.filterKey4a = arr2;
      // label duplication ......................... end
      this.filterKey4 = arr;
      this.filterRating4 = `filters=${this.bazaarData.ReviewStatistics.FilterCategory[4].Key}:${this.filterKey4}`;
      this.getdatas(0);
      this.paginationValidation = 0;
      this.currentPaginationPage = 1;
    },
    FilterCategory5(val) {
      if (this.filterKey5 === '') {
        this.filterKey5 = val.key;
      } else {
        this.filterKey5 = `${this.filterKey5}%2c${val.key}`;
      }
      this.filterKey5a.push(val);
      let duplicates = this.filterKey5.split('%2c').reduce(function (acc, el, i, arr) {
        if (arr.indexOf(el) !== i && acc.indexOf(el) < 0) acc.push(el);
        return acc;
      }, []);
      this.filterKey5 = this.filterKey5.split('%2c');
      this.filterKey5 = [...new Set(this.filterKey5)];
      // dropdown duplication............ start
      let arr = '';
      for (let i = 0; i < this.filterKey5.length; i++) {
        if (this.filterKey5[i] != duplicates[0]) {
          if (arr === '') {
            arr = this.filterKey5[i];
          } else {
            arr = `${arr}%2c${this.filterKey5[i]}`;
          }
        }
      }
      // dropdown duplication............ end
      // label duplication ................. start
      this.filterKey5a = Object.values(
        this.filterKey5a.reduce((a, c) => {
          a[c.key] = c;
          return a;
        }, {}),
      );
      let arr2 = [];
      for (let i = 0; i < this.filterKey5a.length; i++) {
        if (this.filterKey5a[i].key != duplicates[0]) {
          arr2.push(this.filterKey5a[i]);
        }
      }
      this.filterKey5a = arr2;
      // label duplication ......................... end
      this.filterKey5 = arr;
      this.filterRating5 = `filters=${this.bazaarData.ReviewStatistics.FilterCategory[5].Key}:${this.filterKey5}`;
      this.getdatas(0);
      this.paginationValidation = 0;
      this.currentPaginationPage = 1;
    },
    RemoveAll() {
      this.filterKey0 = '';
      this.filterKey0a = [];
      this.filterKey1 = '';
      this.filterKey1a = [];
      this.filterKey2 = '';
      this.filterKey2a = [];
      this.filterKey3 = '';
      this.filterKey3a = [];
      this.filterKey4 = '';
      this.filterKey4a = [];
      this.filterKey5 = '';
      this.filterKey5a = [];
      this.getdatas(0);
      this.paginationValidation = 0;
      this.currentPaginationPage = 1;
    },
    startData() {
      const arr = [
        { rating: 5, cout: 0 },
        { rating: 4, cout: 0 },
        { rating: 3, cout: 0 },
        { rating: 2, cout: 0 },
        { rating: 1, cout: 0 },
      ];
      for (let i = 5; i > 0; i--) {
        let dataValue = this.bazaarData.ReviewStatistics.RatingDistribution.filter(function (rr) {
          return rr.RatingValue == i;
        });
        if (dataValue.length > 0) {
          for (let j = 0; j < arr.length; j++) {
            if (arr[j].rating == dataValue[0].RatingValue) {
              arr[j].cout = dataValue[0].Count;
            }
          }
        }
      }
      this.datas = arr;
    },
    keywords() {
      return this.words.split(' ');
    },
    helpfullyes(contentid, feedbacktype, helpfulcount) {
      let PositiveFeedback = helpfulcount + 1;
      this.localstorageDatas.push({
        id: contentid,
        TotalPositiveFeedbackCount: PositiveFeedback,
        TotalNegativeFeedbackCount: 0,
        statuss: 'yes',
      });
      localStorage.product_ratings = JSON.stringify(this.localstorageDatas);
      for (let j = 0; j < this.posts.Results.length; j++) {
        if (
          JSON.parse(localStorage.product_ratings).findIndex(
            (x) => x.id === this.posts.Results[j].Id,
          ) != -1
        ) {
          this.posts.Results[j].TotalPositiveFeedbackCount =
            this.posts.Results[j].TotalPositiveFeedbackCount + 1;
          this.posts.Results[j]['cookieStatus'] = true;
        }
      }
      this.getdatas(this.paginationValidation);
      axios
        .get(
          `/api/BazaarVoice/PostFeedbackReview?contentid=${contentid}&feedbacktype=${feedbacktype}`,
        )
        .then(() => {
          console.log('yes...');
        });
    },
    helpfullno(contentid, feedbacktype, helpfulcount) {
      let NegativeFeedback = helpfulcount + 1;
      this.localstorageDatas.push({
        id: contentid,
        TotalPositiveFeedbackCount: 0,
        TotalNegativeFeedbackCount: NegativeFeedback,
        statuss: 'no',
      });
      localStorage.product_ratings = JSON.stringify(this.localstorageDatas);
      for (let j = 0; j < this.posts.Results.length; j++) {
        if (
          JSON.parse(localStorage.product_ratings).findIndex(
            (x) => x.id === this.posts.Results[j].Id,
          ) != -1
        ) {
          this.posts.Results[j].TotalNegativeFeedbackCount =
            this.posts.Results[j].TotalNegativeFeedbackCount + 1;
          this.posts.Results[j]['cookieStatus'] = true;
        }
      }
      this.getdatas(this.paginationValidation);
      axios
        .get(
          `/api/BazaarVoice/PostFeedbackReview?contentid=${contentid}&feedbacktype=${feedbacktype}`,
        )
        .then(() => {
          console.log('no...');
        });
    },
    helpfullreport(contentid, feedbacktype) {
      this.localstorageDatasReport.push({ id: contentid, statuss: 'appropriate' });
      localStorage.product_ratings_report = JSON.stringify(this.localstorageDatasReport);
      this.getdatas(this.paginationValidation);
      axios
        .get(
          `/api/BazaarVoice/PostFeedbackReview?contentid=${contentid}&feedbacktype=${feedbacktype}`,
        )
        .then(() => {});
    },
    labelName() {
      this.quantity = this.bazaarData.ReviewStatistics.SecondaryRatingsAveragesOrder;
      this.productRate = this.bazaarData.ReviewStatistics.SecondaryRatingsAverages;
    },
    productLabel() {
      this.quantity = this.bazaarData.ReviewStatistics.SecondaryRatingsAveragesOrder;
      this.productRate = this.bazaarData.ReviewStatistics.SecondaryRatingsAverages;
      const array = [
        'WieBewertestDuDenDuft_1',
        'Effizienz',
        'VertraglichkeitBew',
        'Feuchtigkeitswirkung_1',
      ];
      let newObj = this.productRate;
      const filtered = Object.keys(newObj)
        .filter((key) => array.includes(key))
        .reduce((obj, key) => {
          obj[key] = newObj[key];
          return obj;
        }, {});
      this.labelArr = filtered;
    },
    highest() {
      let obj = this.datas;
      const obje = [];
      Object.keys(obj).forEach(function (key) {
        obje.push(obj[key].cout);
      });
      this.high = obje;
      this.total = this.high.reduce(function (a, b) {
        return a + b;
      });
    },
    getdatasBack() {
      if (this.currentPaginationPage > 1) {
        const a = this.paginationValidation - 2;
        this.currentPaginationPage = this.currentPaginationPage - 1;
        this.paginationValidation = a;
        this.getdatas(this.paginationValidation);
      }
    },
    getdatasNext() {
      if (this.showPagination > this.currentPaginationPage) {
        const a = this.paginationValidation + 2;
        let b = this.currentPaginationPage + 1;
        this.currentPaginationPage = b;
        this.paginationValidation = a;
        this.getdatas(this.paginationValidation);
      }
    },
    closeSearchPopup() {
      this.popupstatus = false;
      document.body.classList.remove('modal-open');
    },
    getsearchdatasBack() {
      if (this.searchcurrentPaginationPage > 1) {
        const a = this.searchpaginationValidation - 2;
        this.searchcurrentPaginationPage = this.searchcurrentPaginationPage - 1;
        this.searchpaginationValidation = a;
        this.searchdata();
      }
    },
    getsearchdatasNext() {
      if (this.searchshowPagination > this.searchcurrentPaginationPage) {
        const a = this.searchpaginationValidation + 2;
        let b = this.searchcurrentPaginationPage + 1;
        this.searchcurrentPaginationPage = b;
        this.searchpaginationValidation = a;
        this.searchdata();
      }
    },
    sortDatas() {
      this.getdatas(0);
      this.paginationValidation = 0;
      this.currentPaginationPage = 1;
    },
    searchdatanew() {
      this.reviewSearch = this.reviewSearch.trim();
      this.searchcurrentPaginationPage = 1;
      this.searchpaginationValidation = 0;
      this.searchdata(0);
    },
    searchdata() {
      if (this.reviewSearch.length > 0) {
        this.popupstatus = true;
        document.body.classList.add('modal-open');
        axios
          .get(
            `/api/BazaarVoice/GetProductReviewsBySearch?search=${this.reviewSearch.trim()}&offset=${this.searchpaginationValidation}&productid=${this.productId}&locale=${this.currentlocale}`,
          )
          .then((response) => {
            let postvalues = response.data;
            this.searchresults = response.data;
            for (let j = 0; j < postvalues.Results.length; j++) {
              let dates = new Date(
                postvalues.Results[j].SubmissionTime.match(/\d+/)[0] * 1,
              ).getTime();
              postvalues.Results[j].SubmissionTime = timeAgo.format(dates - 24 * 60 * 60 * 1000);
            }
            this.searchingresults = postvalues;
            this.TotalResultsValidation = response.data.TotalResults;
            if (this.TotalResultsValidation > 2) {
              this.searchshowPagination = Math.round(this.TotalResultsValidation / 2);
            } else {
              this.searchshowPagination = 1;
            }
          })
          .catch((e) => {
            console.log(e);
          });
      }
    },
    buildFilterParams() {
      const filters = [
        { key: this.filterKey0, rating: this.filterRating0 },
        { key: this.filterKey1, rating: this.filterRating1 },
        { key: this.filterKey2, rating: this.filterRating2 },
        { key: this.filterKey3, rating: this.filterRating3 },
        { key: this.filterKey4, rating: this.filterRating4 },
        { key: this.filterKey5, rating: this.filterRating5 },
      ];
      return filters
        .filter((f) => f.key !== '')
        .map((f) => `${f.rating}&`)
        .join('');
    },
    formatSubmissionTime(review) {
      const dates = new Date(review.SubmissionTime.match(/\d+/)[0] * 1).getTime();
      review.SubmissionTime = timeAgo.format(dates - 24 * 60 * 60 * 1000);
    },
    getProductRatings() {
      return localStorage.product_ratings === undefined
        ? null
        : JSON.parse(localStorage.product_ratings);
    },
    getProductRatingsReport() {
      return localStorage.product_ratings_report === undefined
        ? null
        : JSON.parse(localStorage.product_ratings_report);
    },
    updateFeedbackCounts(review, productRatings) {
      const ratingIndex = productRatings.findIndex((x) => x.id === review.Id);
      if (ratingIndex === -1) {
        return false;
      }
      const rating = productRatings[ratingIndex];
      if (rating.statuss === 'yes') {
        review.TotalPositiveFeedbackCount++;
      } else {
        review.TotalNegativeFeedbackCount++;
      }
      return true;
    },
    processCookieStatus(review) {
      const productRatings = this.getProductRatings();
      if (!productRatings) {
        review.cookieStatus = false;
        return;
      }
      review.cookieStatus = this.updateFeedbackCounts(review, productRatings);
    },
    processReportStatus(review) {
      const productRatingsReport = this.getProductRatingsReport();
      if (!productRatingsReport) {
        review.reportStatus = false;
        return;
      }
      const reportIndex = productRatingsReport.findIndex((x) => x.id === review.Id);
      if (reportIndex === -1) {
        review.reportStatus = false;
        return;
      }
      const report = productRatingsReport[reportIndex];
      review.reportStatus = report.statuss === 'appropriate';
    },
    processReviewResult(review) {
      this.formatSubmissionTime(review);
      this.processCookieStatus(review);
      this.processReportStatus(review);
    },
    calculatePagination(totalResults) {
      this.TotalResultsValidation = totalResults;
      this.showPagination = totalResults > 2 ? Math.round(totalResults / 2) : 1;
    },
    getdatas(val) {
      const filterParams = this.buildFilterParams();
      const url = `/api/BazaarVoice/GetProductReviews?${filterParams}sorting=${this.sortdatass}&offset=${val}&productid=${this.productId}`;

      axios
        .get(url)
        .then((response) => {
          const post = response.data;
          this.datass = response.data;

          post.Results.forEach((review) => this.processReviewResult(review));

          this.posts = post;
          this.calculatePagination(response.data.TotalResults);
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
};
</script>
